import { render } from "./Mockup.vue?vue&type=template&id=b69cf974&scoped=true"
import script from "./Mockup.vue?vue&type=script&lang=js"
export * from "./Mockup.vue?vue&type=script&lang=js"

import "./Mockup.vue?vue&type=style&index=0&id=b69cf974&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69cf974"]])

export default __exports__